import { r as t, h as e } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const a = ".sc-add-circle-icon-h{display:flex}", s = a, i = class {
  constructor(c) {
    t(this, c), this.width = "24", this.height = "25";
  }
  render() {
    return e("svg", { key: "9f125acd265edd23296a9f0fffc299514b80243d", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e("path", { key: "ea79df5238b3eb4cb0305c1e65c7becf526d8187", d: "M12 2.5c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10ZM12 4a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm0 3.5a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 12 7.5Z", fill: "currentColor" }));
  }
};
i.style = s;
const d = ".sc-close-icon-h{display:flex}", l = d, o = class {
  constructor(c) {
    t(this, c), this.width = "16", this.height = "16";
  }
  render() {
    return e("svg", { key: "8c588cb34c8e834a5fa4bc0b4c677c1e44723fee", width: "21", height: "21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e("g", { key: "2a0c968755966779f42e75f6c9eed733b3fd7f8e", "clip-path": "url(#a)" }, e("path", { key: "1723f91c026a17c279d24adef0ea9aace474890c", d: "M5.73 4.574a.75.75 0 1 0-1.061 1.06l4.419 4.42-4.42 4.42a.75.75 0 1 0 1.061 1.06l4.42-4.42 4.419 4.42a.75.75 0 0 0 1.06-1.06l-4.419-4.42 4.42-4.42a.75.75 0 1 0-1.061-1.06l-4.42 4.42-4.419-4.42Z", fill: "currentColor" })), e("defs", { key: "a3d657a8d3fe6523db89cd7ba6be4efd6503e08b" }, e("clipPath", { key: "066108607aca4366de715418353804e95a418ebf", id: "a" }, e("path", { key: "97a435e87556734381f370d0952316da051a45e6", fill: "#fff", transform: "translate(.148 .054)", d: "M0 0h20v20H0z" }))));
  }
};
o.style = l;
export {
  i as add_circle_icon,
  o as close_icon
};
